/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useState } from 'react';
import { Selection } from '@quero-delivery/quero-components-web';
import Tooltip from 'rc-tooltip';
import { toast } from 'react-toastify';
import debounce from 'lodash/debounce';

import styles from './styles.module.scss';

import useRequest from '@/hooks/util/useRequest';
import Requests from '@/Services/Requests';
import type { Place } from '@/_types/places';

interface Props {
  place: Place;
}

function ToggleOnlyDedicate({ place }: Props) {
  const [isOnlyDedicateMotoboys, setIsOnlyDedicateMotoboys] = useState(
    !!place.hasOnlyDeliverymenDedicated,
  );

  const debounceUpdatePlaceDedicationIsActive = useRef(
    debounce(updatePlaceDedicationIsActive, 500),
  );

  const { request } = useRequest();

  async function updatePlaceDedicationIsActive(
    isOnlyDedicateMotoboys: boolean,
  ) {
    try {
      const response = await request(
        Requests.places.updateIsOnlyDedicatedMotoboys(
          place._id,
          isOnlyDedicateMotoboys,
        ),
      );

      if (!response?.r) {
        toast.warn(response?.errors.join(' - '));
      }
    } catch (err: any) {
      const errorMessage = err.response?.data.error;
      toast.error(errorMessage);
    }
  }

  return (
    <Tooltip
      overlay={
        <b>
          Ao habilitar a dedicação de pedido, somente o entregador que estiver
          dedicado ao estabelecimento receberá as solicitações de entrega.
        </b>
      }
      placement="top"
      mouseEnterDelay={0.5}
      overlayClassName="white-tooltip"
    >
      <div className={styles.toggleOnlyDedicate}>
        <Selection
          disabled={!place.isCloud}
          type="switch"
          checked={isOnlyDedicateMotoboys}
          onClick={() => {
            setIsOnlyDedicateMotoboys(!isOnlyDedicateMotoboys);
            debounceUpdatePlaceDedicationIsActive.current(
              !isOnlyDedicateMotoboys,
            );
          }}
          className="switch-with-colors"
        />
        <b>Dedicação de pedido</b>
      </div>
    </Tooltip>
  );
}

export default ToggleOnlyDedicate;
